import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ProjectListComponent } from '../project/modules/settings/components/project-list/project-list.component';
import { CountrySearchComponent } from './components/country-search/country-search.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalComponent } from './components/modal/modal.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SelectSearchComponent } from './components/select-search/select-search.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { StateSearchComponent } from './components/state-search/state-search.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { DropdownRadioComponent } from './dropdown-radio/dropdown-radio.component';
import { StringSlicePipe } from './pipe/string-slice.pipe';
import { AnalyticsComponent } from '../project/modules/analytics/analytics.component';
import { ApiLogsComponent } from '../project/modules/logs/components/api-logs/api-logs.component';



@NgModule({
  declarations: [
    SidebarComponent,
    NavbarComponent,
    TabsComponent,
    StringSlicePipe,
    PaginationComponent,
    ModalComponent,
    DropdownRadioComponent,
    SelectSearchComponent,
    CountrySearchComponent,
    StateSearchComponent,
    ProjectListComponent,
    LoaderComponent,
    AnalyticsComponent,
        ApiLogsComponent
    
    // FilterDropdownComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule
  ],
  exports: [
    FormsModule,
    SidebarComponent,
    TabsComponent,
    ReactiveFormsModule,
    StringSlicePipe,
    PaginationComponent,
    ModalComponent,
    DropdownRadioComponent,
    SelectSearchComponent,
    CountrySearchComponent,
    StateSearchComponent,
    NavbarComponent,
    LoaderComponent,
    AnalyticsComponent,
        ApiLogsComponent

  ]
})
export class SharedModule { }
